import React from "react";

const ShareLinkSVG = ({isActive}) => {
  if (isActive) {
    return (
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="40" height="40" rx="4" fill="#DEF6FF"/>
        <path
          d="M11 14C11 11.7909 12.7909 10 15 10H23L26 13.5L29 16.6489V26C29 28.2091 27.2091 30 25 30H15C12.7909 30 11 28.2091 11 26V14Z"
          fill="#4279DE"/>
        <path
          d="M24.3999 17.4H28.5031C28.7776 17.4 29.0001 17.1775 29.0001 16.903C29.0001 16.3142 28.8258 15.7386 28.4992 15.2487L28.3249 14.9873C27.4439 13.6656 26.4344 12.4343 25.3113 11.3112L24.807 10.8069C24.2903 10.2902 23.5896 10 22.859 10C22.6055 10 22.3999 10.2056 22.3999 10.4591V15.4C22.3999 16.5046 23.2953 17.4 24.3999 17.4Z"
          fill="#6FC5F2"/>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M14 15C14 14.4477 14.4477 14 15 14H17C17.5523 14 18 14.4477 18 15C18 15.5523 17.5523 16 17 16H15C14.4477 16 14 15.5523 14 15Z"
              fill="#173D84"/>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M16.2929 23.7071C15.9024 23.3166 15.9024 22.6834 16.2929 22.2929L19.2929 19.2929C19.6834 18.9024 20.3166 18.9024 20.7071 19.2929L23.7071 22.2929C24.0976 22.6834 24.0976 23.3166 23.7071 23.7071C23.3166 24.0976 22.6834 24.0976 22.2929 23.7071L21 22.4142V25.5C21 26.0523 20.5523 26.5 20 26.5C19.4477 26.5 19 26.0523 19 25.5V22.4142L17.7071 23.7071C17.3166 24.0976 16.6834 24.0976 16.2929 23.7071Z"
              fill="white"/>
      </svg>

    )
  }

  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="4" fill="#F4F4F4"/>
      <path
        d="M11 14C11 11.7909 12.7909 10 15 10H23L26 13.5L29 16.6489V26C29 28.2091 27.2091 30 25 30H15C12.7909 30 11 28.2091 11 26V14Z"
        fill="#C3C2C7"/>
      <path
        d="M24.3999 17.4H28.5031C28.7776 17.4 29.0001 17.1775 29.0001 16.903C29.0001 16.3142 28.8258 15.7386 28.4992 15.2487L28.3249 14.9873C27.4439 13.6656 26.4344 12.4343 25.3113 11.3112L24.807 10.8069C24.2903 10.2902 23.5896 10 22.859 10C22.6055 10 22.3999 10.2056 22.3999 10.4591V15.4C22.3999 16.5046 23.2953 17.4 24.3999 17.4Z"
        fill="#2C2C2F"/>
      <path fillRule="evenodd" clipRule="evenodd"
            d="M14 15C14 14.4477 14.4477 14 15 14H17C17.5523 14 18 14.4477 18 15C18 15.5523 17.5523 16 17 16H15C14.4477 16 14 15.5523 14 15Z"
            fill="#2C2C2F"/>
      <path fillRule="evenodd" clipRule="evenodd"
            d="M16.2929 23.7071C15.9024 23.3166 15.9024 22.6834 16.2929 22.2929L19.2929 19.2929C19.6834 18.9024 20.3166 18.9024 20.7071 19.2929L23.7071 22.2929C24.0976 22.6834 24.0976 23.3166 23.7071 23.7071C23.3166 24.0976 22.6834 24.0976 22.2929 23.7071L21 22.4142V25.5C21 26.0523 20.5523 26.5 20 26.5C19.4477 26.5 19 26.0523 19 25.5V22.4142L17.7071 23.7071C17.3166 24.0976 16.6834 24.0976 16.2929 23.7071Z"
            fill="white"/>
    </svg>

  )
};

export default ShareLinkSVG;
